// extracted by mini-css-extract-plugin
export default {"choices":"styles_choices__rDbzz","validate-button":"styles_validate-button__+mXj9","local":"styles_local__UPw9H"};